import * as React from "react";

/** ``value`` once it has stopped changing for ``ms`` (the Ask panel
 *  searches 250 ms after the last keystroke). */
export function useDebouncedValue<T>(value: T, ms: number): T {
  const [settled, setSettled] = React.useState(value);
  React.useEffect(() => {
    const id = window.setTimeout(() => setSettled(value), ms);
    return () => window.clearTimeout(id);
  }, [value, ms]);
  return settled;
}
